import { render, staticRenderFns } from "./Empleo.vue?vue&type=template&id=2bf43ec8&"
import script from "./Empleo.vue?vue&type=script&lang=js&"
export * from "./Empleo.vue?vue&type=script&lang=js&"
import style0 from "./Empleo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports